import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { DateRange } from 'react-day-picker';
import { PeriodPicker } from '@/components/ui/period-picker';

interface ABTestMetricsHeaderProps {
  testName: string;
  testStatus: 'active' | 'finished' | 'draft';
  dateRange?: DateRange;
  onDateRangeChange?: (range: DateRange | undefined) => void;
  onBackClick: () => void;
}

export function ABTestMetricsHeader({ 
  testName, 
  testStatus,
  dateRange, 
  onDateRangeChange,
  onBackClick 
}: ABTestMetricsHeaderProps) {
  useLanguage();
  const statusLabels = {
    active: 'Ativo',
    finished: 'Finalizado',
    draft: 'Rascunho'
  };

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-foreground">
          {translateInterfaceText("Métricas do Teste A/B")}</h1>
        <button
          onClick={onBackClick}
          className="flex items-center gap-1.5 text-sm text-primary hover:underline transition-all"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          {translateInterfaceText("Voltar")}</button>
        <p className="text-sm text-muted-foreground">
          {translateInterfaceText("Teste:")}{" "}{testName} • {statusLabels[testStatus]}
        </p>
      </div>
      
      <div className="flex items-center gap-3">
        {dateRange && onDateRangeChange && (
          <PeriodPicker
            value={dateRange}
            onChange={onDateRangeChange}
            align="end"
            className="md:min-w-[240px]"
          />
        )}
      </div>
    </div>
  );
}
